module.exports = __webpack_public_path__ + "f90f81546f7ef234930dcecc4e2519db.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/CoronaBar.jpg
// module id = 838
// module chunks = 0